/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import SearchFilter from "components/search-filter-list/search-filter-list";
import ListGallery from "components/model-selector/gallery/list_gallery";
import GalleryContext from "components/model-selector/gallery/context";
import { useMountedState } from "react-use";

const DialogGalleryPanel = () => {
    
    const galleryCtx = useContext(GalleryContext);
    const { models = [], setModels, searchFunction, filter, filterValue } = galleryCtx;
    const [needsRefresh, setNeedsRefresh] = React.useState(false);
    const mounted = useMountedState();
    
    return (
        <Fragment>
            <div className='simplicity-image-selector-window-content-gallery'>
                <SearchFilter
                    items={models}
                    setItems={setModels}
                    autoLoad={true}
                    searchFunction={searchFunction}
                    needsRefresh={needsRefresh}
                    setNeedsRefresh={setNeedsRefresh}
                    filter={filter}
                    filterValue={filterValue}
                    instruction={"Select from existing models"}
                    mounted={mounted}
                >
                    <ListGallery />
                </SearchFilter>
            </div>
        </Fragment>
    );
};

export default DialogGalleryPanel;
